import styled from "styled-components";
import FirstRoundLetterComp from "../../../components/FirstRoundLetter/FirstRoundLetter";
import AssigneeTooltip from "../../../components/Tooltip/AssigneeTooltip";
import { AssigneeRoundImage, RoundPersonImage } from "../../../styledComponents/createProject";
import avatar5 from "../../../assets/img/avatar_5.svg";

const InfoWindowContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  min-width: 280px;
  max-width: 320px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const JobName = styled.h4`
  margin: 0 0 8px 0;
  font-family: "Mona Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #000e2a;
  white-space: normal;
  word-break: break-word;
`;

const SlotInfo = styled.p`
  margin: 0 0 8px 0;
  font-family: "Mona Sans", sans-serif;
  font-size: 12px;
  color: #666e7f;
  line-height: 1.4;
`;

const AssigneeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AssigneesLabel = styled.p`
  margin: 0;
  font-family: "Mona Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #000e2a;
`;

const AssigneeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const AssigneeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  font-family: "Mona Sans", sans-serif;
  font-size: 11px;
  color: #000e2a;
`;

const JobMarkerInfoWindow = ({ job, orgTimezone }) => {
  if (!job) return null;

  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    const moment = require("moment-timezone");
    return moment(timeString + "Z")
      .tz(orgTimezone || moment.tz.guess())
      .format("h:mm a");
  };

  return (
    <InfoWindowContainer>
      <JobName>{job.name || "Unnamed Job"}</JobName>

      {job.start_time && (
        <SlotInfo>
          <strong>{formatTime(job.start_time)}</strong> -{" "}
          <strong>{formatTime(job.end_time)}</strong>
        </SlotInfo>
      )}

      {job.assignees && job.assignees.length > 0 && (
        <AssigneeSection>
          <AssigneesLabel>Assignees ({job.assignees.length})</AssigneesLabel>
          <AssigneeList>
            {job.assignees.map((assignee, index) => (
              <AssigneeItem key={assignee.id || index}>
                <div style={{ position: "relative", width: "20px", height: "20px" }}>
                  {assignee.avatar ? (
                    <img
                      src={assignee.avatar}
                      alt={assignee.first_name}
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        background: assignee.color || "#ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      {`${assignee.first_name?.charAt(0) || ""}${
                        assignee.last_name?.charAt(0) || ""
                      }`.toUpperCase()}
                    </div>
                  )}
                </div>
                <span>{assignee.first_name} {assignee.last_name}</span>
              </AssigneeItem>
            ))}
          </AssigneeList>
        </AssigneeSection>
      )}
    </InfoWindowContainer>
  );
};

export default JobMarkerInfoWindow;
